import './AddFirm.scss';
import axios from "axios";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { RadioButton } from "primereact/radiobutton";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../store/hooks";
import { useFormik } from 'formik';
import { Dropdown } from "primereact/dropdown";
import { InputMask } from 'primereact/inputmask';
import { setFirmPopupVisibility } from "../../features/firmSlice";
import { useDispatch } from "react-redux";
import { setShowLoading } from '../../features/sharedSlice';
import { Toast } from 'primereact/toast';
import { MultiSelect } from 'primereact/multiselect';
import { Calendar } from 'primereact/calendar';
import moment from 'moment';

enum SorguTypes {
    VERGINO = 'VERGINO',
    MERSIS = 'MERSIS',
    ESNAFNO = 'ESNAFNO',
    KAYSIS = 'KAYSIS',
    TCKIMLIK = 'TCKIMLIK',
}

export default function Etahsis(props: any) {
    const toast = useRef<any>();
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { feature, getFirmaInfo, fields } = props;
    const [sorguType, setSorguType] = useState<SorguTypes>(SorguTypes.VERGINO);
    const [allNace, setAllNace] = useState<any[]>([]);
    const [sorguResponse, setSorguResponse] = useState<any[]>([]);
    const [firmaTipiDomain, setFirmaTipiDomain] = useState<any>();
    const addFirmVisibility = useAppSelector(state => state.firm.addFirmVisibility);

    useEffect(() => {
        firmaForm.resetForm()
    }, [sorguType])

    const getToken = () => {
        return localStorage.getItem('token');
    };
    const isFormFieldValid = (name: string, form: any) => !!(form.touched[name] && form.errors[name]);
    const getFormErrorMessage = (name: string, form: any) => {
        return isFormFieldValid(name, form) && <small className="p-error">{form.errors[name]}</small>;
    };
    const naceOptionTemplate = (option: any) => {
        return (
            <div style={{ maxWidth: '200px' }}>
                {`${option.nacerev2} - ${option.nacerev2tanim}`}
            </div>
        );
    }
    const firmaForm: any = useFormik({
        validateOnMount: true,
        initialValues: {
            firmaTipi: '',
            firmaTuru: null,
            firmaAdi: '',
            vergiNo: '',
            vergiDairesi: '',
            ticariSicilNo: '',
            sgkSicilNo: '',
            mersisNo: '',
            sanayiSicilNo: '',
            adres: '',
            telefon: '',
            cepTelefon: '',
            ePosta: '',
            fax: '',
            webAdresi: '',
            firmaSektoru: ''
        },
        validate: (data) => {
            let errors: any = {};

            if (!data.firmaAdi) {
                errors.firmaAdi = 'Firma Adı Zorunlu Alandır.';
            }

            // if (!data.telefon) {
            //     errors.telefon = 'Telefon Zorunlu Alandır.';
            // }

            if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(data.ePosta)) {
                errors.ePosta = 'Hatalı E-posta Adresi. Örnek: example@email.com';
            }

            return errors;
        },
        onSubmit: () => { },
        validateOnChange: true,
        validateOnBlur: false
    });

    const yetkiliForm = useFormik({
        initialValues: {
            yetkililer: []
        },
        validate: (data) => {
            let errors: any = {};
            for (const [index, yetkili] of (data.yetkililer as any).entries()) {
                if (!(yetkili as any).unvan) {
                    errors[`unvan_${index}`] = 'Ünvan Zorunlu Alandır.';
                }

                if (!(yetkili as any).telefon) {
                    errors[`telefon_${index}`] = 'Telefon Zorunlu Alandır.';
                }

                if (!(yetkili as any).ePosta) {
                    errors[`ePosta_${index}`] = 'E-posta Zorunlu Alandır.';
                } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test((yetkili as any).ePosta)) {
                    errors[`ePosta_${index}`] = 'Hatalı E-posta Adresi. Örnek: example@email.com';
                }
            }
            return errors;
        },
        onSubmit: () => { }
    });

    useEffect(() => {
        axios(process.env.REACT_APP_BASE_URL + `rest/v1/osb-util/allNace?token${getToken()}`).then(res => {
            setAllNace(res.data.data)
        })
        getFirmaTypes()
    }, [addFirmVisibility])

    const getFirmaTypes = async () => {
        const firmaTipi = await axios(process.env.REACT_APP_BASE_URL + `rest/v1/domain/4420/options?token=${getToken()}`)
        if (firmaTipi) {
            setFirmaTipiDomain(firmaTipi.data.options);
        }
    }

    const setFirmaForm = (firma: any) => {
        firmaForm.setFieldValue('firmaTipi', firma.FirmaNeviGrup.includes('ŞİRKET') ? firmaTipiDomain.find((tip: any) => tip.id === 1) : firmaTipiDomain.find((tip: any) => tip.id === 0));
        // firmaForm.setFieldValue('firmaTipi', firma.FirmaNeviGrup === 'LİMİTED ŞİRKET' ? firmaTipiDomain.find((tip: any) => tip.id === 1) : firmaTipiDomain.find((tip: any) => tip.id === 0));
        firmaForm.setFieldValue('firmaAdi', firma.Unvani);
        firmaForm.setFieldValue('vergiNo', firma.VergiNo);
        firmaForm.setFieldValue('vergiDairesi', firma.VergiDairesi);
        firmaForm.setFieldValue('ticariSicilNo', firma.SicilNo);
        firmaForm.setFieldValue('mersisNo', firma.MersisNo);
        firmaForm.setFieldValue('adres', firma.Adres);
        setYetkiliForm(firma.MersisNo);
    }
    const setFirmaFormTC = (firma: any) => {
        firmaForm.setFieldValue('firmaTipi', firmaTipiDomain.find((tip: any) => tip.id === 0));
        // firmaForm.setFieldValue('firmaTipi', firma.FirmaNeviGrup === 'LİMİTED ŞİRKET' ? firmaTipiDomain.find((tip: any) => tip.id === 1) : firmaTipiDomain.find((tip: any) => tip.id === 0));
        firmaForm.setFieldValue('firmaAdi', firma.Ad + ' ' + firma.Soyad);
        firmaForm.setFieldValue('vergiNo', `${firma.TCKimlikNo}`);
        firmaForm.setFieldValue('ticariSicilNo',  `${firma.TCKimlikNo}`);
        firmaForm.setFieldValue('mersisNo',  `${firma.TCKimlikNo}`);
    }

    const setFirmaFormByEsnaf = (firma: any) => {
        firmaForm.setFieldValue('firmaTipi', firmaTipiDomain.find((tip: any) => tip.id === 0));
        firmaForm.setFieldValue('firmaAdi', `${firma.KisiBilgileri?.Adi} ${firma.KisiBilgileri?.Soyadi}`);
        firmaForm.setFieldValue('vergiNo', firma.SicilBilgileri?.SicilBilgisiSonuc?.VergiNo);
        firmaForm.setFieldValue('ticariSicilNo', firma.SicilBilgileri?.SicilBilgisiSonuc?.SicilNo);
        firmaForm.setFieldValue('adres', firma.Adresi);
        setYetkiliFromEsnaf(firma.KisiBilgileri);
    }

    const setYetkiliForm = async (mersisNo: string) => {
        // try {
        //     (yetkiliForm as any).values.yetkililer = []
        //     const response = await axios(process.env.REACT_APP_BASE_URL + `rest/v1/osb-util/temsilciInfoByMersis/${mersisNo}?token=${getToken()}`)
        //     const yetkililer = response.data.data;
        //     for (const yetkili of yetkililer) {
        //         const adSoyadArray = yetkili.AdiSoyadiUnvani.split(' ')
        //         const soyad = adSoyadArray[adSoyadArray.length - 1]
        //         adSoyadArray.splice(-1)
        //         const ad = adSoyadArray.join(' ')
        //         const yetkiliModel = {
        //             tcKimlikNo: yetkili.KimlikNo,
        //             ad: ad,
        //             soyad: soyad,
        //             unvan: yetkili.Gorevi,
        //             telefon: '',
        //             ePosta: '',
        //             fromService: true
        //         };

        //         (yetkiliForm as any).values.yetkililer.push(yetkiliModel)
        //     }
        //     //dispatch(setShowLoading(false))
        // } catch (error) {
        //     console.warn(error);
        //     //dispatch(setShowLoading(false))
        // }

    }

    const setYetkiliFromEsnaf = (esnaf: any) => {
        try {
            const yetkiliModel = {
                tcKimlikNo: esnaf.TCKimlikNo,
                ad: esnaf.Adi,
                soyad: esnaf.Soyadi,
                unvan: '',
                telefon: '',
                ePosta: '',
                fromService: true
            };

            (yetkiliForm as any).values.yetkililer.push(yetkiliModel)
            dispatch(setShowLoading(false))
        } catch (error) {
            console.warn(error);
            dispatch(setShowLoading(false))
        }
    }

    const sorguForm = useFormik({
        initialValues: {
            vergiNo: '',
            ticariSicilNo: '',
            mersisNo: '',
            tcKimlikNo: '',
            tcKimlikNo2: '',
            birthday: undefined
        },
        validate: (data) => {
            let errors: any = {};

            if (sorguType === SorguTypes.VERGINO && !data.vergiNo) {
                errors.vergiNo = 'Vergi No Zorunlu Alandır.';
            } else if (!/^\d*$/.test(data.vergiNo)) {
                errors.vergiNo = 'Vergi No Sadece Sayılardan Oluşabilir.';
            }

            if (sorguType === SorguTypes.VERGINO && !data.ticariSicilNo) {
                errors.ticariSicilNo = 'Ticari Sicil No Zorunlu Alandır.';
            }

            if (sorguType === SorguTypes.MERSIS && !data.mersisNo) {
                errors.mersisNo = 'Mersis No Zorunlu Alandır.';
            } else if (!/^\d*$/.test(data.mersisNo)) {
                errors.mersisNo = 'Mersis No Sadece Sayılardan Oluşabilir.';
            }

            if (sorguType === SorguTypes.ESNAFNO && !data.tcKimlikNo) {
                errors.tcKimlikNo = 'TC Kimlik No Zorunlu Alandır.';
            } else if (sorguType === SorguTypes.ESNAFNO && data.tcKimlikNo.toString().length !== 11) {
                errors.tcKimlikNo = 'TC Kimlik No 11 Hane Olmak Zorundadır.';
            }

            if (sorguType === SorguTypes.TCKIMLIK && !data.tcKimlikNo2) {
                errors.tcKimlikNo = 'TC Kimlik No Zorunlu Alandır.';
            } else if (sorguType === SorguTypes.TCKIMLIK && data.tcKimlikNo2.toString().length !== 11) {
                errors.tcKimlikNo2 = 'TC Kimlik No 11 Hane Olmak Zorundadır.';
            }

            return errors;
        },
        onSubmit: async (data) => {
            dispatch(setShowLoading(true))
            try {
                let response;
                let firma;
                switch (sorguType) {
                    case SorguTypes.VERGINO:
                        response = await axios(process.env.REACT_APP_BASE_URL + `rest/v1/osb-util/firmaInfoByVergiNo/${data.vergiNo}/${data.ticariSicilNo}?token=${getToken()}`)
                        firma = response.data.data;
                        setSorguResponse([firma])
                        setFirmaForm(firma);
                        break;
                    case SorguTypes.MERSIS:
                        response = await axios(process.env.REACT_APP_BASE_URL + `rest/v1/osb-util/firmaInfoByMersis/${data.mersisNo}?token=${getToken()}`)
                        firma = response.data.data;
                        setSorguResponse([firma])
                        setFirmaForm(firma)
                        break;
                    case SorguTypes.ESNAFNO:
                        response = await axios(process.env.REACT_APP_BASE_URL + `rest/v1/osb-util/firmaInfoByTc/${data.tcKimlikNo}?token=${getToken()}`)
                        firma = response.data.data;
                        setSorguResponse([firma])
                        setFirmaFormByEsnaf(firma);
                        break;
                    case SorguTypes.TCKIMLIK:
                        response = await axios(process.env.REACT_APP_BASE_URL + `rest/v1/osb-util/kisiInfoByTcAndBirthDate/${data.tcKimlikNo2}/${moment(data.birthday).format("DD.MM.YYYY")}?token=${getToken()}`)
                        firma = response.data.data;
                        setSorguResponse([firma])
                        setFirmaFormTC(firma);
                        break;
                    default:
                        break;
                }
            } catch (error: any) {
                toast.current.show({ severity: 'error', summary: t('TEXT.Fail'), detail: error.response.data.message });
                console.warn(error);
                dispatch(setShowLoading(false))
            }
        }
    });

    const kaydetYeniYatirimci = async (e: any) => {
        e.preventDefault()
        const values: any = firmaForm.values

        let parselFirma = {
            firma_turu: values.firmaTuru,
            telefon_no: values.telefon,
            cep_telefonu: values.cepTelefon,
            eposta: values.ePosta,
            fax: values.fax,
            web_adresi: values.webAdresi,
            active: true,
            naceIds: [],
        }

        let copyYeniYatirimci = {
            active: true,
            adres: values.adres,
            firma_adi: values.firmaAdi,
            //   firma_gid: values.firma_gid,
            firma_tipi: values.firmaTipi.id,
            mersis_no: values.mersisNo,
            sanayi_sicil_no: String(values.sanayiSicilNo),
            sgk_sicil_no: String(values.sgkSicilNo),
            sicil_no: values.ticariSicilNo,
            vergi_dairesi: values.vergiDairesi,
            vergi_no: values.vergiNo,
        }
        const naceList: any[] = []
        naceList.push(firmaForm.values.firmaSektoru.map((f: any) => { return f.id }))

        if (!naceList) {
            toast.current.show({ severity: 'error', summary: t('TOAST.Unsuccessful'), detail: 'Nace Seçimi Zorunludur.' });
            return;
        }
        // delete firmaForm.values.firmaSektoru.id
        // delete firmaForm.values.firma_turu

        let firma: any;
        let parselFirmaResponse: any;

        parselFirma.naceIds = naceList[0]

        try {
            const firmaResponse = await axios.post(`${process.env.REACT_APP_BASE_URL}rest/v1/osb-parsel/firma?token=${getToken()}`, copyYeniYatirimci)
            if (firmaResponse) {
                if (firmaResponse.data.data) {
                    toast.current.show({ severity: 'success', summary: t('TOAST.Unsuccessful'), detail: 'Yeni Firma Eklendi' });
                    firma = firmaResponse.data.data
                }
                if (firmaResponse.data.firmaAlreadyExist) {
                    toast.current.show({ severity: 'success', summary: t('TOAST.Unsuccessful'), detail: 'Varolan Firma Güncellendi' });
                    firma = firmaResponse.data.firmaAlreadyExist
                }
                axios.post(`${process.env.REACT_APP_BASE_URL}rest/v1/osb-parsel/parselFirma/${feature.properties.id}/${firma.id}?token=${getToken()}`, parselFirma).then(res => {
                    getFirmaInfo(fields.id)
                    if (res) {
                        parselFirmaResponse = res.data.data
                        toast.current.show({ severity: 'success', summary: t('TOAST.Unsuccessful'), detail: 'Parsele Yatırımcı Eklendi.' });
                        dispatch(setFirmPopupVisibility(false))
                    }
                }).catch(async error => {
                    const body = { active: false }
                    if (firmaResponse.data.data) {
                        await axios.post(`${process.env.REACT_APP_BASE_URL}rest/v1/osb-parsel/put/firma/${firma.id}?token=${getToken()}`, body)
                    }
                    await axios.post(`${process.env.REACT_APP_BASE_URL}rest/v1/osb-parsel/put/parselFirma/${parselFirmaResponse.id}?token=${getToken()}`, body)

                    console.error(error);
                    toast.current.show({ severity: 'error', summary: t('TOAST.Unsuccessful'), detail: 'Parsele Yatırımcı Eklemede Problem Oluştu.' });
                    // dispatch(setFirmPopupVisibility(false))
                })
            }
        } catch (error: any) {
            console.error(error.response.data.message);
            // dispatch(setFirmPopupVisibility(false))
            return;
        }
    }

    return (
        <>
            {
                addFirmVisibility && <Dialog header={'Yatırımcı Bilgileri'} className="yatirimci-dialog" visible={addFirmVisibility} onHide={() => { dispatch(setFirmPopupVisibility(false)); }}>

                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                            <div style={{ width: '30%', marginRight: '2%', marginTop: '15px' }}>
                                <div className="radio-field">
                                    <RadioButton
                                        value={SorguTypes.VERGINO}
                                        onChange={(e) => setSorguType(e.value)}
                                        checked={sorguType === SorguTypes.VERGINO}
                                    />
                                    <label>{t('FIRM.Query with Tax Number')}</label>
                                </div>
                                <div className="radio-field">
                                    <RadioButton
                                        value={SorguTypes.MERSIS}
                                        onChange={(e) => setSorguType(e.value)}
                                        checked={sorguType === SorguTypes.MERSIS}
                                    />
                                    <label>{t('FIRM.Query with Mersis Number')}</label>
                                </div>
                                <div className="radio-field">
                                    <RadioButton
                                        value={SorguTypes.ESNAFNO}
                                        onChange={(e) => setSorguType(e.value)}
                                        checked={sorguType === SorguTypes.ESNAFNO}
                                    />
                                    <label>{t('FIRM.Query with Tradesman Number')}</label>
                                </div>
                                <div className="radio-field">
                                    <RadioButton
                                        value={SorguTypes.TCKIMLIK}
                                        onChange={(e) => setSorguType(e.value)}
                                        checked={sorguType === SorguTypes.TCKIMLIK}
                                    />
                                    <label>TC Kimlik No ile Sorgula</label>
                                </div>
                                <form onSubmit={sorguForm.handleSubmit}>
                                    {sorguType === SorguTypes.VERGINO && (
                                        <>
                                            <div className="field">
                                                <label>{t('FIRM.Tax number')}</label>
                                                <InputText
                                                    id="vergiNo"
                                                    value={sorguForm.values.vergiNo}
                                                    onChange={sorguForm.handleChange}
                                                    onBlur={sorguForm.handleBlur}
                                                />
                                                {getFormErrorMessage('vergiNo', sorguForm)}
                                            </div>
                                            <div className="field">
                                                <label>{t('FIRM.Commercial Registry Number')}</label>
                                                <InputText
                                                    id="ticariSicilNo"
                                                    value={sorguForm.values.ticariSicilNo}
                                                    onChange={sorguForm.handleChange}
                                                    onBlur={sorguForm.handleBlur}
                                                />
                                                {getFormErrorMessage('ticariSicilNo', sorguForm)}
                                            </div>
                                        </>
                                    )}
                                    {sorguType === SorguTypes.MERSIS && (
                                        <>
                                            <div className="field">
                                                <label>{t('FIRM.Mersis Number')}</label>
                                                <InputText
                                                    id="mersisNo"
                                                    value={sorguForm.values.mersisNo}
                                                    onChange={sorguForm.handleChange}
                                                    onBlur={sorguForm.handleBlur}
                                                />
                                                {getFormErrorMessage('mersisNo', sorguForm)}
                                            </div>
                                        </>
                                    )}
                                    {sorguType === SorguTypes.ESNAFNO && (
                                        <>
                                            <div className="field">
                                                <label>{t('FIRM.Turkish Identity Number')}</label>
                                                <InputText
                                                    min="1"
                                                    type="number"
                                                    id="tcKimlikNo"
                                                    value={sorguForm.values.tcKimlikNo}
                                                    onKeyDown={(e: any) => {
                                                        const deger = e.target.value;
                                                        if (e.key === "e" || e.key === "+" || e.key === "-" || e.key === "." || e.key === ",") {
                                                            e.preventDefault()
                                                        }// bu tuşları engelle.
                                                        else if (/*selection === "" && */deger && deger.toString().length === 11) {
                                                            if (!isNaN(+e.key)) {
                                                                e.preventDefault()
                                                            }
                                                        }
                                                    }}
                                                    onInput={(e: any) => {
                                                        e.target.value = e.target.value.substring(0, 11)
                                                    }}
                                                    onChange={sorguForm.handleChange}
                                                    onBlur={sorguForm.handleBlur}
                                                />
                                                {getFormErrorMessage('tcKimlikNo', sorguForm)}
                                            </div>
                                        </>
                                    )}
                                    {sorguType === SorguTypes.TCKIMLIK && (
                                        <>
                                            <div className="field">
                                                <label>{t('FIRM.Turkish Identity Number')}</label>
                                                <InputText
                                                    min="1"
                                                    type="number"
                                                    id="tcKimlikNo2"
                                                    value={sorguForm.values.tcKimlikNo2}
                                                    onKeyDown={(e: any) => {
                                                        const deger = e.target.value;
                                                        if (e.key === "e" || e.key === "+" || e.key === "-" || e.key === "." || e.key === ",") {
                                                            e.preventDefault()
                                                        }// bu tuşları engelle.
                                                        else if (/*selection === "" && */deger && deger.toString().length === 11) {
                                                            if (!isNaN(+e.key)) {
                                                                e.preventDefault()
                                                            }
                                                        }
                                                    }}
                                                    onInput={(e: any) => {
                                                        e.target.value = e.target.value.substring(0, 11)
                                                    }}
                                                    onChange={sorguForm.handleChange}
                                                    onBlur={sorguForm.handleBlur}
                                                />
                                                {getFormErrorMessage('tcKimlikNo2', sorguForm)}
                                            </div>
                                            <div className="field">
                                                <label htmlFor="birthday" className="p-d-block">Doğum Tarihi</label>
                                                <Calendar
                                                    id="birthday"
                                                    value={sorguForm.values.birthday}
                                                    onChange={sorguForm.handleChange}
                                                    onBlur={sorguForm.handleBlur}
                                                    dateFormat="dd/mm/yy"
                                                />
                                            </div>
                                        </>
                                    )}
                                    {sorguType !== SorguTypes.KAYSIS && (
                                        <Button disabled={!sorguForm.isValid} type="submit" label="Sorgula"></Button>
                                    )}
                                </form>
                            </div>

                            <form style={{ width: '95%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                                <div style={{ display: 'flex' }}>

                                    <div style={{ width: '45%', marginRight: '1%' }}>
                                        <div className="field">
                                            <label>{t('FIRM.Company Type')}</label>
                                            <Dropdown
                                                id="firmaTipi"
                                                value={firmaForm.values.firmaTipi}
                                                optionLabel="desc"
                                                options={firmaTipiDomain}
                                                onChange={firmaForm.handleChange}
                                                onBlur={firmaForm.handleBlur}
                                                disabled
                                            />
                                        </div>
                                        <div className="field">
                                            <label>{t('FIRM.Company Name/Title')}*</label>
                                            <InputText
                                                disabled
                                                id="firmaAdi"
                                                value={firmaForm.values.firmaAdi}
                                                onChange={firmaForm.handleChange}
                                                onBlur={firmaForm.handleBlur}
                                            />
                                            {getFormErrorMessage('firmaAdi', firmaForm)}
                                        </div>

                                        <div className="field">
                                            <label>{t('FIRM.Tax number')}*</label>
                                            <InputText
                                                disabled={sorguType !== SorguTypes.KAYSIS}
                                                min="0"
                                                type="number"
                                                id="vergiNo"
                                                value={firmaForm.values.vergiNo}
                                                onChange={firmaForm.handleChange}
                                                onBlur={firmaForm.handleBlur}
                                            />
                                            {getFormErrorMessage('vergiNo', firmaForm)}
                                        </div>
                                        <div className="field">
                                            <label>{t('FIRM.Commercial Registry Number')}*</label>
                                            <InputText
                                                disabled={sorguType !== SorguTypes.KAYSIS}
                                                id="ticariSicilNo"
                                                value={firmaForm.values.ticariSicilNo}
                                                onChange={firmaForm.handleChange}
                                                onBlur={firmaForm.handleBlur}
                                            />
                                            {getFormErrorMessage('ticariSicilNo', firmaForm)}
                                        </div>
                                        <div className="field">
                                            <label>{t('FIRM.SSI Registry Number')}</label>
                                            <InputText
                                                // disabled={sorguType !== SorguTypes.KAYSIS}
                                                min="0"
                                                id="sgkSicilNo"
                                                type="number"
                                                onKeyDown={(e: any) => {
                                                    const deger = e.target.value;
                                                    if (e.key === "e" || e.key === "+" || e.key === "-" || e.key === "." || e.key === ",") {
                                                        e.preventDefault()
                                                    }// bu tuşları engelle.
                                                    else if (deger && deger.toString().length === 50) {
                                                        if (!isNaN(+e.key)) {
                                                            e.preventDefault()
                                                        }
                                                    }
                                                }}
                                                onInput={(e: any) => {
                                                    e.target.value = e.target.value.substring(0, 50)
                                                }}
                                                value={firmaForm.values.sgkSicilNo}
                                                onChange={firmaForm.handleChange}
                                                onBlur={firmaForm.handleBlur}
                                            />
                                            {getFormErrorMessage('sgkSicilNo', firmaForm)}
                                        </div>
                                    </div>

                                    <div style={{ width: '45%', marginRight: '1%' }}>
                                        <div className="field">
                                            <label>Kiracı mı?*</label>
                                            <div style={{ display: 'flex', alignItems: 'center', height: '35px' }}>
                                                <RadioButton style={{ marginRight: '0.5em' }} name="firmaTuru" value={2} onChange={firmaForm.handleChange} checked={firmaForm.values.firmaTuru === 2} />
                                                <label style={{ marginRight: '1em' }} htmlFor="yes-button">{t('TEXT.Yes')}</label>
                                                <RadioButton style={{ marginRight: '0.5em' }} name="firmaTuru" value={1} onChange={firmaForm.handleChange} checked={firmaForm.values.firmaTuru === 1} />

                                                <label htmlFor="no-button">{t('TEXT.No')}</label>
                                            </div>
                                        </div>
                                        <div className="field">
                                            <label>{t('FIRM.Tax Administration')}</label>
                                            <InputText
                                                id="vergiDairesi"
                                                value={firmaForm.values.vergiDairesi}
                                                onChange={firmaForm.handleChange}
                                                disabled
                                            />
                                        </div>
                                        <div className="field">
                                            <label>{t('FIRM.Industry Registry Number')}</label>
                                            <InputText
                                                // disabled={sorguType !== SorguTypes.KAYSIS}
                                                id="sanayiSicilNo"
                                                value={firmaForm.values.sanayiSicilNo}
                                                onChange={firmaForm.handleChange}
                                                min="0"
                                                type="number"
                                                onKeyDown={(e: any) => {
                                                    const deger = e.target.value;
                                                    if (e.key === "e" || e.key === "+" || e.key === "-" || e.key === "." || e.key === ",") {
                                                        e.preventDefault()
                                                    }// bu tuşları engelle.
                                                    else if (deger && deger.toString().length === 8) {
                                                        if (!isNaN(+e.key)) {
                                                            e.preventDefault()
                                                        }
                                                    }
                                                }}
                                                onInput={(e: any) => {
                                                    e.target.value = e.target.value.substring(0, 8)
                                                }}
                                                onBlur={firmaForm.handleBlur}
                                            />
                                            {getFormErrorMessage('sanayiSicilNo', firmaForm)}
                                        </div>
                                        <div className="field">
                                            <label>{t('FIRM.Mersis Number')}</label>
                                            <InputText
                                                disabled={sorguType !== SorguTypes.KAYSIS}
                                                type="number"
                                                id="mersisNo"
                                                value={firmaForm.values.mersisNo}
                                                onChange={firmaForm.handleChange}
                                                onBlur={firmaForm.handleBlur}
                                                min="0"
                                            />
                                            {getFormErrorMessage('mersisNo', firmaForm)}
                                        </div>
                                        <div className="field">
                                            <label>{t('FIRM.Communication Address')}</label>
                                            <InputText
                                                disabled={sorguType !== SorguTypes.ESNAFNO && sorguType !== SorguTypes.KAYSIS}
                                                id="adres"
                                                value={firmaForm.values.adres}
                                                onChange={firmaForm.handleChange}
                                                onBlur={firmaForm.handleBlur}
                                            />
                                            {getFormErrorMessage('adres', firmaForm)}
                                        </div>
                                    </div>

                                    <div style={{ width: '45%' }}>
                                        <div className="field">
                                            <label>{t('FIRM.Phone')}</label>
                                            <InputMask
                                                id="telefon"
                                                mask="0 (999) 999-9999"
                                                value={firmaForm.values.telefon}
                                                onChange={firmaForm.handleChange}
                                                onBlur={firmaForm.handleBlur}
                                            />
                                            {getFormErrorMessage('telefon', firmaForm)}
                                        </div>
                                        <div className="field">
                                            <label>{t('FIRM.Cell Phone')}</label>
                                            <InputMask
                                                id="cepTelefon"
                                                mask="0 (999) 999-9999"
                                                value={firmaForm.values.cepTelefon}
                                                onChange={firmaForm.handleChange}
                                                onBlur={firmaForm.handleBlur}
                                            />
                                            {getFormErrorMessage('telefon', firmaForm)}
                                        </div>
                                        <div className="field">
                                            <label>{t('FIRM.E-Posta')}</label>
                                            <InputText
                                                id="ePosta"
                                                maxLength={50}
                                                onInput={(e: any) => {
                                                    e.target.value = e.target.value.substring(0, 50)
                                                }}
                                                value={firmaForm.values.ePosta}
                                                onChange={firmaForm.handleChange}
                                                onBlur={firmaForm.handleBlur}
                                            />
                                            {getFormErrorMessage('ePosta', firmaForm)}
                                        </div>
                                        <div className="field">
                                            <label>{t('FIRM.Fax')}</label>
                                            <InputMask
                                                id="fax"
                                                mask="0 (999) 999-9999"
                                                value={firmaForm.values.fax}
                                                onChange={firmaForm.handleChange}
                                                onBlur={firmaForm.handleBlur}
                                            />
                                            {getFormErrorMessage('fax', firmaForm)}
                                        </div>
                                        {/* <div className="field">
                                        <label>{t('FIRM.Cap Address')}</label>
                                        <InputText
                                            id="kepAdresi"
                                            value={firmaForm.values.kepAdresi}
                                            onChange={firmaForm.handleChange}
                                        />
                                    </div> */}
                                        <div className="field">
                                            <label>{t('FIRM.Web address')}</label>
                                            <InputText
                                                maxLength={50}
                                                onInput={(e: any) => {
                                                    e.target.value = e.target.value.substring(0, 50)
                                                }}
                                                id="webAdresi"
                                                value={firmaForm.values.webAdresi}
                                                onChange={firmaForm.handleChange}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div>
                                    <div className="field">
                                        <MultiSelect
                                            id="firmaSektoru"
                                            display="chip"
                                            options={allNace}
                                            value={firmaForm.values.firmaSektoru}
                                            onChange={firmaForm.handleChange}
                                            optionLabel="nacerev2"
                                            itemTemplate={naceOptionTemplate}
                                            filter
                                            showClear
                                            filterBy="nacerev2,nacerev2tanim"
                                            placeholder={t('FIRM.Select Nace Code') + '*'}
                                        />
                                        {/* {getFormErrorMessage('firmaSektoru', firmaForm)} */}
                                    </div>
                                </div>

                                <div>
                                    <Button
                                        label={t('BUTTON.Save')}
                                        onClick={kaydetYeniYatirimci}
                                        disabled={sorguResponse.length === 0 || !firmaForm.values.firmaSektoru || !firmaForm.values.firmaTuru || (firmaForm.values.ePosta && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(firmaForm.values.ePosta))}
                                        style={{ width: '100%' }} />
                                </div>
                            </form>
                        </div>
                        {/* <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginTop: '10px' }}>
                  <Button
                    label={t('BUTTON.Back')}
                    className="p-button-info"
                    onClick={() => {
                      setActiveIndex(activeIndex - 1);
                    }}
                  ></Button>
                  <Button
                    disabled={!firmaForm.isValid}
                    label={t('BUTTON.Next')}
                    className="p-button-info"
                    onClick={() => {
                      setActiveIndex(activeIndex + 1);
                    }}
                  ></Button>
                </div> */}
                    </div>
                </Dialog>
            }
            <Toast ref={toast} />
        </>
    )
}